<template>
    <button class="btn-primary" @click="nextPage" :data-page="currentPage">{{title}}</button>
</template>


<script>
export default {
  props: {
    title: String,
    currentPage: String
  },
  methods:{
    nextPage () {
    this.$store.commit('nextPage')
     //this.$emit('nextpage')
   }
  }
}
</script>